<div class="ppv-remaining-indicator" [class.bg-blue]="contentTypeIsBook" [class.top-15]="contentTypeIsCatalog" container="body" placement="top" ngbTooltip="{{getTooltip()}}" *ngIf="showRental && !parentShowingRental">
    <i class="iconlace iconlace-clock"></i>
</div>
